/**
 * Class strings of the organizer pages (mock `event.html` Registration settings / Orders views,
 * `account.html` views): one place for the kit values, the same idiom as `registration.ui.js`.
 */

/** Content column of an organizer page: h1 16 px under the nav, 24 between blocks. */
export const ORG_PAGE = 'org-page flex flex-col gap-6 px-(--x004) pb-24 pt-4 nav:px-(--x006)'

/** Ghost button 33 px (mock `.btn.btn-ghost`): outline --nav-bd, field surface on hover. */
const ORG_BTN_GHOST_BASE =
    's-focus-ring inline-flex min-h-[33px] cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-[5px] border bg-white px-3 text-sm font-medium text-[#272727] transition-colors disabled:cursor-default disabled:opacity-40 max-[760px]:min-h-11'
export const ORG_BTN_GHOST = `${ORG_BTN_GHOST_BASE} border-[#dbdadf] hover:bg-[#f7f7f9]`

/**
 * The Dates "Open now" / "Close now" buttons (William, 15 Oct 2026): the state colour on the border
 * only, the text stays ink (colour = event state), a tint of the same colour on hover.
 */
export const ORG_BTN_OPEN_NOW = `${ORG_BTN_GHOST_BASE} border-[#4ebf1d] hover:bg-[#4ebf1d]/8`
export const ORG_BTN_CLOSE_NOW = `${ORG_BTN_GHOST_BASE} border-[#b93a2c] hover:bg-[#b93a2c]/8`

/** Primary button (mock `.btn.btn-primary`): solid ink, the ONE primary of the screen. */
export const ORG_BTN_PRIMARY =
    's-focus-ring inline-flex min-h-[33px] cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-[5px] border border-[#272727] bg-[#272727] px-4 text-sm font-medium text-white transition-opacity hover:opacity-90 disabled:cursor-default disabled:opacity-40 max-[760px]:min-h-11'

/** Danger text button (mock `.set-danger`). */
export const ORG_BTN_DANGER =
    's-focus-ring inline-flex h-[33px] cursor-pointer items-center gap-1.5 rounded-[5px] border-0 bg-transparent px-2 text-sm text-[#b93a2c] transition-colors hover:bg-[#b93a2c]/8 max-[760px]:min-h-11'

/** Underlined text link (mock `.set-link`). */
export const ORG_LINK =
    'cursor-pointer border-0 bg-transparent p-0 text-sm text-[#272727] underline underline-offset-2 hover:opacity-80'

/** Text field (mock `.fld`): 33 px, field surface, radius 5. */
export const ORG_INPUT =
    'org-fld box-border h-[33px] w-full rounded-[5px] border border-[#dbdadf] bg-[#f7f7f9] px-2.5 text-sm text-[#272727] outline-none placeholder:text-[#dbdadf] focus:border-[#272727] max-[760px]:h-11'

export const ORG_TEXTAREA =
    'org-fld box-border min-h-24 w-full resize-y rounded-[5px] border border-[#dbdadf] bg-[#f7f7f9] px-2.5 py-2 text-sm text-[#272727] outline-none placeholder:text-[#dbdadf] focus:border-[#272727]'

/** Small note under a control (mock `.set-note`). */
export const ORG_NOTE = 'm-0 block text-xs leading-[1.4] text-[#9498a6]'

export const ORG_ERR = 'text-[#b93a2c]'

/** Monochrome small chip (mock `.chip-sm`). */
export const ORG_CHIP =
    'inline-flex min-h-[22px] items-center whitespace-nowrap rounded-[5px] border border-[#dbdadf] px-2 text-xs text-[#5b5f6e]'
export const ORG_CHIP_ON = 'border-[#272727] bg-[#272727] text-white'

/** Two-column grid of fields (mock `.set-grid`). */
export const ORG_GRID = 'grid grid-cols-1 items-start gap-x-6 gap-y-4 min-[761px]:grid-cols-2'
export const ORG_GRID_3 = 'grid grid-cols-1 items-start gap-x-6 gap-y-4 min-[761px]:grid-cols-3'

/** Dashed empty state (mock `.set-empty`). */
export const ORG_EMPTY =
    'm-0 rounded-[10px] border border-dashed border-[#dbdadf] p-4 text-center text-sm text-[#9498a6]'

/** Table (mock `.set-table`). */
export const ORG_TABLE = 'org-table w-full border-collapse text-sm text-[#272727]'

/** The edit accent (mock `--edit`, the Figma blue, an accepted charter deviation). */
export const ORG_EDIT = '#1672ec'

/** Danger red on white. */
export const ORG_DANGER = '#b93a2c'
